import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=0c0611d0&scoped=true&v-if=user&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0611d0",
  null
  
)

export default component.exports